import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import translations from '../../../common/constants/translations';
import { DOMAIN_ACTION_TYPES, DOMAIN_TYPE_RADIO_BUTTON_LABELS } from './constants';

import Typography from 'fuse-ui/components/Typography';
import RadioGroup from 'fuse-ui/components/RadioGroup';
import Radio from 'fuse-ui/components/Radio';
import FormControlLabel from 'fuse-ui/components/FormControlLabel';
import Divider from 'fuse-ui/components/Divider';
import FormControl from '@material-ui/core/FormControl';

import DomainManagementBulkTypesRadioButtons from './domain-management-bulk-type-radio-buttons';

// The radio buttons should appear in the following order:
// Add Domains, Change Domain Type, Remove Domains
const DOMAIN_ACTION_TYPES_RADIO_BUTTONS = ['add', 'changeType', 'remove']
    .map( domainActionType => (
        {
            domainActionType,
            label: DOMAIN_ACTION_TYPES[domainActionType]
        } )
    );

// The radio buttons should appear in the following order:
// Sending, Nonsending
const DOMAIN_TYPES = ['sending', 'nonsending']
    .map( domainType => (
        {
            domainType,
            label: translations[domainType]
        } )
    );

const styles = theme => ( {
    divider: {
        marginBottom: theme.spacing.unit,
        marginLeft: `-${theme.spacing.unit * 3}px`,
        marginRight: `-${theme.spacing.unit * 3}px`,
        marginTop: theme.spacing.unit * 2,
    },
    formControlNoLeftMargin: {
        marginLeft: 0,
    },
} );

const DomainManagementBulkForm = ( {
    classes,
    domainActionType,
    domainList,
    domainListErrorMessage,
    domainTypeSelected,
    onChangeDomainActionType,
    onChangeDomainList,
    onChangeDomainType,
} ) => {
    return (
        <React.Fragment>
            <FormControl component="fieldset">
                <Typography variant="overline" color="textSecondary" gutterBottom>What's the intent?</Typography>
                <RadioGroup
                    value={domainActionType}
                    data-automation-id="manage-in-bulk-side-panel-domain-action-type-radio-group"
                    onChange={onChangeDomainActionType}>
                    {
                        DOMAIN_ACTION_TYPES_RADIO_BUTTONS.map(
                            ( { domainActionType, label } ) => ( <FormControlLabel
                                className={classes.formControlNoLeftMargin }
                                key={domainActionType}
                                value={domainActionType}
                                label={label}
                                data-automation-id={`domain-action-type-${domainActionType}`}
                                control={<Radio />} /> )
                        )
                    }
                </RadioGroup>
            </FormControl>
            <Divider className={classes.divider} />
            <DomainManagementBulkTypesRadioButtons
                selectedAction={domainActionType}
                domainListErrorMessage={domainListErrorMessage}
                domainTypes={(
                    <FormControl component="fieldset">
                        <Typography variant="overline" color="textSecondary" gutterBottom>{DOMAIN_TYPE_RADIO_BUTTON_LABELS[domainActionType]}</Typography>
                        <RadioGroup
                            data-automation-id="manage-in-bulk-side-panel-domain-type-radio-group"
                            value={domainTypeSelected}
                            onChange={onChangeDomainType}>
                            {
                                DOMAIN_TYPES.map(
                                    ( { domainType, label } ) => ( <FormControlLabel
                                        className={classes.formControlNoLeftMargin }
                                        key={domainType}
                                        value={domainType}
                                        label={label}
                                        data-automation-id={`domain-type-${domainType}`}
                                        control={<Radio />} /> )
                                )
                            }
                        </RadioGroup>
                    </FormControl>
                )}
                textAreaValue={domainList}
                onChange={onChangeDomainList}
            />
        </React.Fragment>
    );
};

DomainManagementBulkForm.propTypes = {
    classes: PropTypes.object,
    domainActionType: PropTypes.string,
    domainList: PropTypes.string,
    domainListErrorMessage: PropTypes.string,
    domainTypeSelected: PropTypes.string,
    onChangeDomainActionType: PropTypes.func.isRequired,
    onChangeDomainList: PropTypes.func.isRequired,
    onChangeDomainType: PropTypes.func.isRequired,
};

export default withStyles( styles )( DomainManagementBulkForm );
